import type { ReactNode } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/shadcn/accordion";

const Heading = ({ children }: { children: string }) => (
  <p className="mt-4 mb-1 text-sm font-semibold first:mt-0">{children}</p>
);

const Body = ({ children }: { children: ReactNode }) => (
  <p className="my-1 text-sm text-muted-foreground">{children}</p>
);

/** Long-form help, collapsed by default so it doesn't dominate the page. */
export const EmailOptionsHelp = () => (
  <Accordion type="single" collapsible>
    <AccordionItem value="email-options" className="border-none">
      <AccordionTrigger className="py-0 text-sm font-semibold hover:no-underline">
        More detail about tasks from emails
      </AccordionTrigger>
      <AccordionContent className="pt-3 pb-0">
        <Heading>Which emails create a task?</Heading>
        <Body>
          Emails filed in Klipboard CRM: those synced from a connected Microsoft mailbox, and those
          sent to your Klipboard CRM filing address by BCC or forwarding. An email is only filed
          when one of its addresses matches a contact or company, so other emails never create a task.
        </Body>

        <Heading>Which customer is the task for?</Heading>
        <Body>
          Each email creates at most one task. It's linked to the first matching contact, looking at
          the sender, then the recipients, then anyone copied in, and to that contact's company. If no
          contact matches, it's linked to the first matching company.
        </Body>

        <Heading>Who is the task assigned to?</Heading>
        <Body>The user the email was filed for owns the task and is assigned to it.</Body>

        <Heading>Completed or open?</Heading>
        <Body>
          A completed task logs that the email happened. An open task is a reminder to follow up: it
          stays on task lists, and the email shows whether it has been dealt with, until someone
          completes it.
        </Body>

        <Heading>How are working days counted?</Heading>
        <Body>
          Working days follow your account's working days calendar, so weekends and holidays are
          skipped. If the calendar doesn't cover the date, Monday to Friday is used instead.
        </Body>

        <Heading>When do changes apply?</Heading>
        <Body>To emails filed after you save. Tasks that already exist aren't changed.</Body>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
);
